// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DAY = "Den \u25be";
export const MONTH = "M\u011bs\u00edc \u25be";
export const YEAR = "Rok \u25be";
export const YOU_DID_NOT_ENTER_VALID_DATE = "Nezadala jsi platn\u00e9 datum.";
